import { useMemo } from 'react';
import { getDisplayedBelowCompletionAssignments } from './LowCompletionAssignmentList.helper';
var AssignmentCompletionRow = function (_a) {
    var name = _a.name, percentComplete = _a.percentComplete;
    return (<div className="c-cw-engagement-insight-card__list-item">
    <span className="c-cw-engagement-insight-card__list-item--name">{name}</span>
    <span>{"".concat(Math.round(percentComplete * 100), "%")}</span>
  </div>);
};
var LowCompletionAssignmentList = function (_a) {
    var assignments = _a.assignments;
    var displayAssignments = useMemo(function () { return getDisplayedBelowCompletionAssignments(assignments); }, [assignments]);
    if (displayAssignments.length === 0) {
        return <div className="c-cw-engagement-insight-card__list">Nothing here yet. As assignments are completed, this section will list assignments below 80% completion.</div>;
    }
    return (<div className="c-cw-engagement-insight-card__list">
      {displayAssignments.map(function (assignment) { return (<AssignmentCompletionRow key={assignment.assignmentId} name={assignment.assignmentName} percentComplete={assignment.percentComplete}/>); })}
    </div>);
};
export default LowCompletionAssignmentList;
